import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const RowContainer = styled.div`
  display: table-row;
  min-width: ${pxToRem(300)};
  &[data-role='header'] {
    display: table-header-group;
    &[data-has-overlay='true'] {
      position: relative;
      > [data-role='header-cell'][data-checkbox='false'] > * {
        opacity: 0;
      }
    }
  }
  &[data-hoverable='true'] {
    transition: background 0.2s;
  }
  &[data-hoverable='true']:hover {
    background: #eff0f0;
  }
`;
